enum LoginSteps {
  emailSearch = 'emailSearch',
  emailFound = 'emailFound',
  mfaChallenge = 'mfaChallenge',
}

type LoginStep = `${LoginSteps}`;

export { LoginStep, LoginSteps };
